import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
  WithFieldValue,
} from 'firebase/firestore'
import { PartFavorite } from '../parts/parts'

const parsePartIds = (raw: unknown): string[] => {
  if (!Array.isArray(raw)) return []
  return Array.from(
    new Set(raw.filter((id): id is string => typeof id === 'string' && id.length > 0)),
  )
}

export const partFavoriteConverter: FirestoreDataConverter<PartFavorite> = {
  toFirestore(favorite: WithFieldValue<PartFavorite>) {
    return favorite
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): PartFavorite {
    const data = snapshot.data(options) as Record<string, unknown>
    const updated_at =
      data.updated_at instanceof Timestamp ? data.updated_at : Timestamp.fromDate(new Date(0))
    return {
      user_id: typeof data.user_id === 'string' ? data.user_id : snapshot.id,
      part_ids: parsePartIds(data.part_ids),
      updated_at,
    }
  },
}
